import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from '../../../common/checkbox';
import { getTransportationsReportExportUrl } from '../../../../utils/common.utils';

type Props = {
  close: () => void;
  reject: () => void;
};

export const DeliveriesReportModal: React.FC<Props> = (props) => {
  const [withReceipts, setWithReceipts] = React.useState(false);
  const [withRecipients, setWithRecipients] = React.useState(false);

  const onSubmit = async () => {
    window.open(
      getTransportationsReportExportUrl(withReceipts, withRecipients),
      '_blank',
    );
    props.close();
  };
  return (
    <div className="modal-dialog">
      <form className="modal-content" onSubmit={onSubmit}>
        <div className="modal-header border-bottom-0 p-4">
          <h3>
            <FormattedMessage
              defaultMessage="Данные по доставкам"
              id="deliveriesReportModal.title"
              description="Надпись на кнопке/заголовок"
            />
          </h3>
          <button
            type="button"
            className="btn-close"
            onClick={() => props.reject()}
          />
        </div>
        <div className="modal-body p-4 pt-0">
          <Checkbox
            title="Маркировка"
            className=""
            checked={true}
            onChange={() => {}}
            disabled={true}
          />{' '}
          <Checkbox
            title="Накладные"
            className=""
            checked={withReceipts}
            onChange={({ target: { checked } }) => setWithReceipts(checked)}
          />{' '}
          <Checkbox
            title="Получатели"
            className=""
            checked={withRecipients}
            onChange={({ target: { checked } }) => setWithRecipients(checked)}
          />
        </div>

        <div className="modal-footer pt-3 p-4 justify-content-center d-flex gap-2">
          <div className="btn btn-light" onClick={() => props.close()}>
            <FormattedMessage
              defaultMessage="Отмена"
              id="deliveryOrder.cancel"
              description="Надпись на кнопке"
            />
          </div>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => onSubmit()}
          >
            Скачать в excel
          </button>
        </div>
      </form>
    </div>
  );
};
